import classNames from 'classnames';
import { FC } from 'react';

import { IcBackIcon } from '@gem/icons';
import { IconButton } from '@gem/ui-kit';

import styles from './BackButton.styles.m.css';

interface IBackButtonProps {
  goBack: () => void;
  className?: string;
}

export const BackButton: FC<IBackButtonProps> = ({ goBack, className }) => {
  return (
    <IconButton
      Icon={IcBackIcon}
      onClick={goBack}
      className={classNames(styles.button, className)}
    />
  );
};
